import React from 'react';
import cls from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Button from 'components/common/Button';
import { redirectToLink } from '../utils';
import noSACodeImgUrl from '../images/no-sa-code.svg';
import s from './style.css';

class NoSACode extends React.Component {
  render() {
    return (
      <div className={s.container}>
        <div className={s.logoWrapper}>
          <img src="images/logoHome.svg" className={s.logo} alt="HomeCredit" />
        </div>
        <div className={s.contentWrapper}>
          <p className={cls(s.title, s.noSpace)}>
            Bạn có cơ hội nhận được khoản vay lên tới
          </p>
          <p className={cls(s.loanAmount, s.noSpace)}>
            <span className={s.amount}>30.000.000</span> VND
          </p>
          <p className={cls(s.paragraph, s.noSpace)}>
            {`Vui lòng kiểm tra chi tiết trên app "Home Credit Tài Chính Online"`}
          </p>
        </div>
        <img src={noSACodeImgUrl} alt="No SA Code introduction" />
        <Button
          type="submit"
          onClick={() => redirectToLink('https://hcv.onelink.me/ausQ/nosacode')}
        >
          TIẾP TỤC TRÊN APP
        </Button>
      </div>
    );
  }
}

export default withStyles(s)(NoSACode);
